export type InterweaveMessageEventType = 'iwb-schedule-request'
| 'iwb-appointment-request'
| 'iwb-healthcare-service-request'
| 'iwb-location-request'
| 'iwb-organization-request';
